import config from "@/config/env";

export const replaceContent = (content: string, position?: string) => {
  return content
    .replaceAll(
      "TANGERINE",
      `<img src="/img/legal/${position}-tang.svg" class="replaced" />`
    )
    .replaceAll(
      "PSTNET FINANCE CORP.",
      `<img src="/img/legal/${position}-pstnet-corp.svg" class="replaced" />`
    )
    .replaceAll(
      "BC1331376",
      `<img src="/img/legal/${position}-pstnet-num.svg" class="replaced" />`
    )
    .replaceAll("{{frontend_url}}", "pst.net")
    .replaceAll("{{support_email}}", "support@pst.net")
    .replaceAll("%support_telegram%", config.telegramSupport)
    .replaceAll("%channel_twitter%", config.twitterChannelEn)
    .replaceAll("%channel_telegram_en%", config.telegramChannelEn)
    .replaceAll("%channel_telegram_ru%", config.telegramChannelRu)
    .replaceAll(
      "%dashboard_payment_page%",
      `${config.dashboardUrl}/app/payments`
    )
    .replaceAll("%dashboard_register%", `${config.dashboardUrl}/register`)
    .replaceAll("%telegram_bot%", config.telegramBot);
};
